import { Menu, MenuProps, styled } from '@mui/material';
import { forwardRef } from 'react';

type ExporerMenuProps = MenuProps & {
  children: React.ReactNode;
};

export const ExplorerMenu = forwardRef<any, ExporerMenuProps>(
  (
    {
      children,
      open,
      anchorEl,
      onClose,
      anchorOrigin = {
        vertical: 'bottom',
        horizontal: 'right',
      },
      transformOrigin = {
        vertical: 'bottom',
        horizontal: 'left',
      },
      slotProps,
      sx,
    },
    ref,
  ) => {
    return (
      <StyledExplorerMenu
        ref={ref}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        slotProps={slotProps}
        sx={sx}
      >
        {children}
      </StyledExplorerMenu>
    );
  },
);

const StyledExplorerMenu = styled(Menu)(({ theme }) => ({
  zIndex: theme.zIndex.tooltip,
  '& .MuiPaper-root': {
    width: 350,
    maxHeight: 450,
    overflowY: 'auto',
    scrollbarWidth: 'thin',
    '& .MuiList-root': {
      padding: theme.spacing(1.5),
      '& .MuiList-root': {
        padding: theme.spacing(0, 1),
        marginLeft: theme.spacing(1),
      },
    },
    '& .MuiMenuItem-root': {
      marginBottom: theme.spacing(0),
      paddingLeft: theme.spacing(1),
      '& .MuiListItemIcon-root': {
        minWidth: 26,
      },
    },
  },
}));
